import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Form, Row, Col } from "react-bootstrap";

const NewPassword = () => {

    // ✅ Separate states for both fields
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
        <div className="Login_sec">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={6}>
                        <div className="login_form">
                            <div className="login_user">
                                <span><i className="bi bi-lock"></i></span>
                                <h5>Create A New Password</h5>
                            </div>
                            <Form>

                                {/* ✅ New Password Field */}
                                <Form.Group className="mb-3 position-relative">
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control
                                        type={showNewPassword ? "text" : "password"}
                                        placeholder="Enter Password"
                                    />
                                    <i
                                        className={`bi ${showNewPassword ? "bi-eye-fill" : "bi-eye-slash-fill"} password-toggle-icon`}
                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                    ></i>
                                </Form.Group>

                                {/* ✅ Confirm Password Field */}
                                <Form.Group className="mb-3 position-relative">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        type={showConfirmPassword ? "text" : "password"}
                                        placeholder="Enter Password"
                                    />
                                    <i
                                        className={`bi ${showConfirmPassword ? "bi-eye-fill" : "bi-eye-slash-fill"} password-toggle-icon`}
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    ></i>
                                </Form.Group>

                                <div className="login_btn">
                                    <a href="#">Submit </a>
                                </div>
                            </Form>

                            <div className="other_sign forget_div">
                                <h6>Still no account? <a href="/register">Sign up</a></h6>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default NewPassword;
